import React from "react";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import {SUBSCRIPTIONS_DETAIL} from "constants.js";
import Button from "features/components/button";
import {func, object, oneOf} from "prop-types";

export const ResourcePaymentSection = (props) => {
    const {data, goToPayment, type} = props;
    if(!data.requires_payment) {
        return null;
    }
    return <div className="payment-section">
        {data.min_level && <div className="payment-upsell upgrade">
            <Title size={24}>{__("common.upsell.upgrade", [{key: "[name]", value: SUBSCRIPTIONS_DETAIL[data.min_level].name}])}</Title>
            <Button title={__("buttons.upsell.upgrade", [{key: "[name]", value: SUBSCRIPTIONS_DETAIL[data.min_level].name}])} onClick={() => window.open(SUBSCRIPTIONS_DETAIL[data.min_level].upsell_link)} icon={"arrow-circle-right"} />
        </div>}
        <div className="payment-upsell pay">
            <Title size={24}>{__(`common.upsell.pay-${type}`, [{key: "[price]", value: data.cost}])}</Title>
            <Button title={__("buttons.upsell.pay")} onClick={goToPayment} type={"outlined"} icon={"cart"} />
        </div>
    </div>
};

ResourcePaymentSection.propTypes = {
    data: object.isRequired,
    goToPayment: func.isRequired,
    type: oneOf(["video", "directory"]).isRequired
};